import { css } from "../../../../../styled-system/css";
import { t } from "../../../../libs/i18n";
import { Heading } from "./heading";

// 文言は登米市から提示された文案（確認依頼_キャンペーンバナー 登米市.xlsx、
// ご注意事項の対象者行のみ 260901_修正依頼_キャンペーンバナー 登米市.xlsx）の原文ママ。
// 数字だけは、原文の全角/半角混在を他市の文言に合わせて半角に統一している。
// 交付金名は原文が「地方創成」だが、正式名称の「地方創生」に直している（登米市の了承済み）。
export const TomeCampaignDetail = () => {
  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      })}
    >
      <Heading>{t("物価高騰対応とめ子育て応援ポイント事業について")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "登米市では食料品やエネルギー価格などの物価高騰の影響が長期化する中で、経済的な負担が増大している子育て世帯を支援するために、とめ子育て応援ポイント（市内参加店において利用可能なみやぎポイント）を付与します。",
        )}
        <br />
        <br />
        {t(
          "「申請する」ボタンからポイントを受け取っていただくと、ただちにポイントが付与され、市内参加店で1ポイント＝1円として利用（利用期間は令和9年1月31日まで）できます。受取期間は令和8年12月31日までですので、お忘れなくお受け取りください。",
        )}
      </p>

      <Heading>{t("申請の方法")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("①「準備する」を押します。")}
        <br />
        {t("②マイナンバーカードをスマートフォンにタッチします。")}
        <br />
        {t("（1日以内にカードをタッチした方などは①②が省略されます）")}
        <br />
        {t("③「申請する」を押します。")}
        <br />
        {t("④ポイントが付与されます。")}
      </p>

      <Heading>{t("スケジュール")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t("■ポイント申請・付与期間")}
        <br />
        {t("令和8年12月31日まで")}
      </p>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
          mt: "12px",
        })}
      >
        {t("■ポイント利用期間")}
        <br />
        {t("令和9年1月31日まで")}
        <br />
        {t("（令和9年2月1日となった時点でポイントが失効します）")}
      </p>

      <Heading>{t("ご注意事項")}</Heading>
      <p
        className={css({
          fontSize: "16px",
          lineHeight: "1.5",
          letterSpacing: "0.16px",
          color: "text.primary",
        })}
      >
        {t(
          "・ご対象者はポイントを申請する時点（令和8年9月1日から令和8年12月31日まで）で登米市に住民登録のある方かつ平成20年4月2日から令和8年11月30日までに生まれた方です。",
        )}
        <br />
        {t(
          "・ポイントを利用できるのは市内の参加店のみです。それ以外の店舗ではご利用できません。",
        )}
        <br />
        {t(
          "・ポイント付与実績を管理するため、申請いただいた方の住所、氏名、生年月日、性別を宮城県から登米市に提供する場合があります。ご了承のうえで申請いただきますようお願いいたします。",
        )}
        <br />
        <br />
        {t(
          "※本事業は国の「物価高騰対応重点支援地方創生臨時交付金」を活用した事業により実施されるものです。",
        )}
      </p>
    </div>
  );
};
